import { reduceImageOnCanvas } from './reduceImageOnCanvas';

export type ConvertCanvasToImageParams = {
  width: number;
  height: number;
  canvas: HTMLCanvasElement;
};

/**
 * Taken from in pdf.js/web/pdf_thumbnail_view.js #convertCanvasToImage
 */
export const getImageFromCanvas = ({ canvas, height, width }: ConvertCanvasToImageParams): string => {
  const reducedCanvas = reduceImageOnCanvas({ canvasImageSource: canvas, height, width });

  if (!reducedCanvas) {
    return '';
  }

  try {
    const image = document.createElement('img');
    image.className = 'thumbnailImage';

    return reducedCanvas.toDataURL();
  } finally {
    // Zeroing the width and height causes Firefox to release graphics
    // resources immediately, which can greatly reduce memory consumption.
    reducedCanvas.width = 0;
    reducedCanvas.height = 0;
  }
};
